// extracted by mini-css-extract-plugin
module.exports = {"customer-coupon-table":"customer-coupon-table-744882de58af8c09f4c7c3fcd8717c54","useStatusUsed":"useStatusUsed-cede5ae87addc637ff4f90568a9a228a"};